<template>
  <div class="opDashboard">
    <vx-card style="min-height: 540px">
     <vs-row class="mb-4 items-center justify-between">
  
  <vs-col class="w-1/2">
    <vs-button
      type="border"
      icon="filter_list"
      @click="filterShow = !filterShow"
    >
      Filter
    </vs-button>

    <div v-if="filterShow" class="mt-3 p-3 border rounded bg-white">
      <vs-row>
        <vs-col class="w-1/12 topPad">
          <span class="inputStyles">From</span>
        </vs-col>
        <vs-col class="w-1/3">
          <Flat-pickr v-model="fromDate" placeholder="From Date" />
        </vs-col>

        <vs-col class="w-1/12 topPad ml-4">
          <span class="inputStyles">To</span>
        </vs-col>
        <vs-col class="w-1/3">
          <Flat-pickr v-model="toDate" placeholder="To Date" />
        </vs-col>
      </vs-row>

      <vs-row class="mt-3">
        <vs-col class="w-1/2 text-left">
          <vs-button type="border" color="warning" @click="clearDateFilter">
            Clear
          </vs-button>
        </vs-col>
        <vs-col class="w-1/2 text-right">
          <vs-button type="gradient" color="success" @click="applyDateFilter">
            Apply
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-col>

  
  <vs-col class="w-1/2 text-right flex items-center justify-end">
    <img
      src="@/assets/images/logo/pdf.jpg"
      width="35"
      class="mr-3 cursor-pointer"
      title="Download PDF"
    />
    <img
      src="@/assets/images/logo/xcl.png"
      width="35"
      class="cursor-pointer"
      title="Download Excel"
    />
  </vs-col>
</vs-row>


      <vue-good-table
        mode="remote"
        :pagination-options="{
          enabled: true,
          perPageDropdown: false,
        }"
        :sort-options="{
          enabled: false,
        }"
        :totalRows="totalRecords"
        :rows="rows"
        :columns="columns"
        :isLoading.sync="isLoading"
        @on-column-filter="onColumnFilter"
        @on-page-change="onPageChange"
        @on-row-dblclick="navigate"
        styleClass="vgt-table condensed"
      >
        <template v-slot:table-row="props">
          <!--<span
            v-if="props.column.field === 'pdf'"
            class="pdf-icon-wrapper"
            @click="openOpPDF(props.row)"
          >
            <vs-icon icon="picture_as_pdf" color="danger" size="20" />
          </span>-->
          <span
  v-if="props.column.field === 'prescription'"
  class="prescription-icon-wrapper"
  @click="checkPrescriptionEntryStatus(props.row)"
>
  <!-- dynamic icon -->
  <vs-icon
  class="prescription-icon"
    :icon="props.row.prescriptionStatus === 'Y' ? 'description' : 'note_add'"
    :color="props.row.prescriptionStatus === 'Y' ? 'primary' : 'success'"
    size="20"
    :title="props.row.prescriptionStatus === 'Y' ? 'Edit Prescription' : 'Add Prescription'"
  />
</span>

          <span v-else-if="props.column.field === 'patientName'">
            <a
              @click="goToPatientTray(props.row.patientId)"
              class="patient-link"
            >
              {{ props.formattedRow[props.column.field] }}
            </a>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </vx-card>
    <print-op
      style="display: none"
      :patientId="selectedPatientId"
      :opPrintData="selectedOpData"
      :patientDetails="selectedPatientDetails"
    />
  </div>
</template>

<script>
import PrintOp from "../components/PrintOp";
import flatPickr from "flatpickr";
 import FlatPickr from 'vue-flatpickr-component';
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    flatPickr,
    PrintOp,
    FlatPickr,
  },

  data() {
    return {
      isLoading: false,
      filterShow:false,
        fromDate: null,
            toDate: null,
      columns: [
        {
          label: "OP NO",
          field: "opNo",
          filterOptions: {
            enabled: true, 
            placeholder: " ", 
            trigger: "", 
          },
          thClass: "text-left pl-4",
          tdClass: "text-left pl-4",
          width: "100px",
        },
        {
          label: "OP DATE",
          field: "opDate",
          type: "date",
          dateInputFormat: "dd/mm/yyyy",
          dateOutputFormat: "dd/mm/yyyy",
          filterOptions: {
            enabled: true, 
            placeholder: "dd/mm/yy", 
            trigger: "", 
          },

          width: "120px",
        },
        {
          label: "PATIENT NAME",
          field: "patientName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },

          width: "210px",
        },

        {
          label: "AGE",
          field: "age",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          thClass: "text-center ",
          tdClass: "text-center",
          width: "110px",
        },
        {
          label: "GENDER",
          field: "gender",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },

          width: "100px",
        },
        {
          label: "PHONE NO",
          field: "patientPhoneNo",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },

          width: "120px",
        },
        {
          label: "PLACE",
          field: "place",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },
          //thClass:'text-center',
          //tdClass:'text-center',
          width: "110px",
        },
        {
          label: "CONSULTING DOCTOR",
          field: "doctorName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: " ", // placeholder for filter input
            trigger: "", //only trigger on enter not on keyup
          },

          width: "180px",
        },
        
        {
  label: "PRESCRIPTION",
  field: "prescription",
  width: "100px",
  tdClass: "text-center",
},

      ],
      rows: [],
      totalRecords: 0,
      serverParams: {
        companyId: this.$session.get("companyId"),
        filter: {},
          fromDate: null,   
          toDate: null,  
        currentPage: 1,
        limit: 10,
      },
      selectedOpData: {}, //  Holds the selected OP details fetched from getopdetails API
      selectedPatientId: null, // The patientId of the selected OP row
      selectedPatientDetails: {},
    };
  },

  mounted() {
    let inputs = ['input[placeholder="dd/mm/yy"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        // dateFormat: "m-d-Y",
        dateFormat: "d-m-Y",
        // mode: "range",
        allowInput: true,
      });
    });
    console.log(
      " Stored filters from Vuex:",
      this.$store.state.opDashboardFilters
    );

    const savedFilters = this.$store.state.opDashboardFilters;

    if (savedFilters) {
      this.serverParams = savedFilters;

      const updatedColumns = this.columns.map((col) => {
        if (savedFilters.filter && savedFilters.filter[col.field]) {
          return {
            ...col,
            filterOptions: {
              ...(col.filterOptions || {}),
              filterValue: savedFilters.filter[col.field],
            },
          };
        }
        return col;
      });
      this.columns = updatedColumns;

      this.$store.commit("updateOpDashboardFilters", null);
    }
    this.loadItems();
  },

  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      console.log(params);
      this.updateParams({
        currentPage: params.currentPage,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      const plainFilters = JSON.parse(JSON.stringify(params.columnFilters));
      // console.log("filter params***",plainFilters)
      this.updateParams({
        filter: plainFilters,
      });
      this.loadItems();
    },
    loadItems() {
      this.isLoading = true;
      // console.log("Sending to backend:", JSON.stringify(this.serverParams, null, 2));
      this.$http
        .post("v2/getopdashboarddetails", JSON.stringify(this.serverParams), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(" Records from backend:", response.data.data.records);
          console.log(
            " Received from backend:",
            JSON.stringify(response.data, null, 2)
          );

          this.totalRecords = response.data.data.recordsTotal;
          this.rows = JSON.parse(JSON.stringify(response.data.data.records));
        })
        .catch((error) => {
          console.log("Error loading data", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

   
    navigate(item) {
      this.$store.commit("updateOpDashboardFilters", this.serverParams);

      this.$router.push({
        path: "opTicket",
        query: {
          patientId: item.row.patientId,
          opId: item.row.opNo,
        },
      });
    },

  
checkPrescriptionEntryStatus(row) {
  const request = {
    companyId: this.$session.get("companyId"),
    patientId: row.patientId,
    refId: row.opNo,
    refTypeId: row.typeId || 1, // adjust if your backend uses this
  };

  this.$http
    .post("checkPrescriptionEntry", JSON.stringify(request), {
      headers: { "Content-Type": "application/json" },
    })
    .then((response) => {
      const data = response.data.data;

      this.$router.push({
        path: "prescription",
        query: {
          patientId: row.patientId,
          opId: row.opNo,
          refType: row.typeId || 1,
          status: data.status, // Y or N
          prescriptionId: data.prescriptionId || null,
              from: 'opdashboard'

        },
      });
    })
    .catch((error) => {
      console.error("Error checking prescription:", error);
    });
},


    formatDate(value) {
      const dateObj = new Date(value);

      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const date = dateObj.getDate().toString().padStart(2, "0");

      const result = `${date}/${month}/${year}`;
      return result;
    },
    goToPatientTray(patientId) {
      this.$router.push({
        path: "/PatientTray",
        query: {
          patientId: patientId,
          from: "opDashboard"
        },
      });
    },
    applyDateFilter() {
  this.updateParams({
    fromDate: this.fromDate,
    toDate: this.toDate,
    currentPage: 1, 
  });

  this.loadItems(); 
},

    clearDateFilter()
    {
        this.fromDate = null;
        this.toDate = null;
    }
  },
};
 /* openOpPDF(row) {
      console.log(" openOpPDF called...");
      console.log(" Clicked row data:", row);
      console.log(" row.opNo (refId):", row.opNo);
      const companyId = this.$session.get("companyId");
      this.selectedPatientId = row.patientId;
      console.log(" Session companyId:", companyId);
      var opRequest = {
        companyId: companyId,

        refId: row.opNo, // opNo used here as refId
        billType: 1,
        attachedFlag: "Y",
      };
      console.log(" Sending opRequest:", opRequest);

      this.$http
        .post("v2/getopdetails", JSON.stringify(opRequest), {
          headers: { "Content-Type": "application/json" },
        })
        .then((opResponse) => {
          console.log(" OP Response:", opResponse.data);
          const opData = opResponse.data.data.opData;
          opData.opDate = this.formatDate(opData.opDate);
          if (opData.appointmentDate) {
            opData.appointmentDate = this.formatDate(opData.appointmentDate);
          }
          this.selectedOpData = opData;

          // Now get patient details
          var patientRequest = {
            companyId: this.$session.get("companyId"),
            regNo: row.patientId,
          };
          console.log("Sending patientRequest:", patientRequest);
          this.$http
            .post("getpatiententry", JSON.stringify(patientRequest), {
              headers: { "Content-Type": "application/json" },
            })
            .then((patientResponse) => {
              this.selectedPatientDetails = patientResponse.data.data;
              //console.log("Ready to print");
              //  console.log(this.selectedOpData);
              //  console.log(this.selectedPatientDetails);

              // Wait for DOM to update before printing
              this.$nextTick(() => {
                this.$htmlToPaper("printOp");
              });
            })
            .catch(() => {
              this.$vs.notify({
                title: "Error",
                text: "Failed to load Patient Details.",
                color: "danger",
                position: "top-center",
              });
            });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Error",
            text: "Failed to load OP Details.",
            color: "danger",
            position: "top-center",
          });
        });
    },*/

</script>

<style>
 .vgt-table thead th {
  background: white;
}
.vgt-wrap__footer {
  background: white;
}
 table.vgt-table {
  font-size: 12px;
  border: none;
}
 .vgt-right-align {
  text-align: left;
}
/* .vgt-responsive {
    min-height:488px;
} */
.vgt-table.condensed tr {
  height: 56px;
}
.vgt-table.condensed td {
  padding-top: 19px;
}
.vgt-input {
  border: none;
}
.vgt-wrap__footer {
  border: none;
}
.flatpickr-calendar {
  width: 305.625px !important;
  /* height: 300.627px !important;  */
}
.flatpickr-rContainer {
  width: 95% !important;
}
.dayContainer {
  min-width: 86% !important;
  max-width: 86% !important;
}


.flatpickr-monthDropdown-months {
  margin-left: -18%;
}
.flatpickr-monthDropdown-month {
  font-size: 11 !important;
}
.flatpickr-next-month {
  right: 57px !important;
}
.flatpickr-months {
  width: 97%;
}
.pdf-icon-wrapper {
  cursor: pointer;
  border-radius: 4px;
  padding: 4px;
  display: inline-block;
  transition: background 0.2s ease;
}
.opDashboard .pdf-icon-wrapper:hover {
  background: #efaaaa;
}
.opDashboard .patient-link {
  color: rgb(90, 90, 155);
  font-weight: bold;
  cursor: pointer;
  text-decoration: none; /*  Remove underline by default */
}

.opDashboard .patient-link:hover {
  text-decoration: underline; /*  Show underline on hover only */
}
.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}
.opDashboard .vgt-table thead th:nth-child(4) input {
  
  text-align: center !important;
}
.prescription-icon {
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.prescription-icon:hover {
  transform: scale(1.1);
  opacity: 0.8;
}
</style>
